import axios from 'axios';
import {SearchResultResponse} from "../types/searchResult";
import {FilterDemand} from "../types/filterDemand";

let searchResultEndpoint = '?ajaxDestination[identifier]=searchResult';

const searchResultQueryParam = '&ajaxDestination[term]=';
const searchResultLimitQueryParam = '&ajaxDestination[limit]=';

const searchResultQueryParams: {[key: string] : any} = {
    offset: 'ajaxDestination[offset]',
    sort: 'ajaxDestination[sortDesc]',
    page: 'ajaxDestination[page]',
    aggregation: 'ajaxDestination[aggregation]'
};

export function getAllSearchBoxResults(searchQuery: string): Promise<SearchResultResponse> {
    return axios.get(getBaseUrl() + searchResultEndpoint + searchResultQueryParam + removeInvalidCharacters(searchQuery) + searchResultLimitQueryParam + '1000')
        .then((response) => response.data);
}

export function getLimitedSearchResults(searchQuery: string): Promise<SearchResultResponse> {
    return axios.get(getBaseUrl() + searchResultEndpoint + searchResultQueryParam + removeInvalidCharacters(searchQuery) + searchResultLimitQueryParam + '3')
        .then((response) => response.data);
}

export function getAllSearchCompletions(searchQuery: string): Promise<SearchResultResponse> {
    return axios.get(getBaseUrl() + searchResultEndpoint + searchResultQueryParam + removeInvalidCharacters(searchQuery))
        .then((response) => response.data);
}

export function getAllSearchResults(searchQuery: string, demand: FilterDemand): Promise<SearchResultResponse> {
    return axios.get(getBaseUrl() + searchResultEndpoint + searchResultQueryParam + removeInvalidCharacters(searchQuery) + createQueryParamsFromDemand(demand))
        .then((response) => response.data);
}


export function getBaseUrl(): string {
    const rootElement: HTMLElement | null = document.querySelector('[data-nezzo-search-search-baseurl]');

    if (rootElement !== null && rootElement.dataset.hasOwnProperty('nezzoSearchSearchBaseurl') && rootElement.dataset.nezzoSearchSearchBaseurl) {
        return rootElement.dataset.nezzoSearchSearchBaseurl;
    }

    if (window.location.origin.includes('localhost')) {
        return 'https://spv.ddev.site/de';
    }

    return '';
}

function removeInvalidCharacters(string: string): string {
    return encodeURIComponent(string.replace(/[\/.#]/g, ''));
}

function createQueryParamsFromDemand(demand : FilterDemand) : string {
    let queryParams = '';

    const demandKeys = Object.keys(demand);
    const castDemand = demand as {[key: string] : any};

    demandKeys.forEach((key : string) => {
        const value = Array.isArray(castDemand[key]) ? castDemand[key].join() : castDemand[key];

        if (value) {
            queryParams += '&' + searchResultQueryParams[key] + '=' + value;
        }
    });

    return queryParams;
}
